import { Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import { trackClick } from '../../features/track';
import { urlBuilder } from '../urlBuilder';

type UserAgreementContentProps = {
  suppressCashReserve?: boolean;
};

const UserAgreementContent: React.FC<UserAgreementContentProps> = ({ suppressCashReserve }) => {
  return (
    <>
      <Text as="p" color="text.weak" css={{ marginBottom: 'space.200', _last: { marginBottom: 'space.0' } }}>
        The terms and conditions in the documents below allow us to provide financial advice to you. They also cover how
        we collect and use your personal information and permit you to access Betterment products in our app that
        require a brokerage account.
      </Text>
      <Text as="p" color="text.weak" css={{ marginBottom: 'space.200', _last: { marginBottom: 'space.0' } }}>
        You confirm that you have reviewed and understand Betterment&apos;s{' '}
        <SambaAutoLink
          to={urlBuilder.getPrivacyPolicy()}
          target="_blank"
          onClick={() => trackClick({ name: 'privacyPolicy', flow: 'UserProfileSetup' })}
        >
          privacy policy{' '}
        </SambaAutoLink>
        and{' '}
        <SambaAutoLink
          to={urlBuilder.getCustomerAgreement()}
          target="_blank"
          onClick={() => trackClick({ name: 'customerAgreement', flow: 'UserProfileSetup' })}
        >
          customer agreements
        </SambaAutoLink>
        , which include the Brokerage Agreement, Advisory Agreement, Consent to Electronic Delivery of Documents and
        Written Communications, FINRA&apos;s Margin Disclosure Statement, and other important agreements. You also
        acknowledge that you have received a copy of our{' '}
        <SambaAutoLink
          to={urlBuilder.getLegalFormCrs()}
          target="_blank"
          onClick={() => trackClick({ name: 'formCrsRelationshipSummary', flow: 'UserProfileSetup' })}
        >
          Form CRS relationship summary
        </SambaAutoLink>
        {' and '}
        <SambaAutoLink
          to={urlBuilder.getAdv()}
          target="_blank"
          onClick={() => trackClick({ name: 'formAdvBrochure', flow: 'UserProfileSetup' })}
        >
          Form ADV brochure
        </SambaAutoLink>
        . Your advisory agreement and brokerage agreement contain a predispute arbitration clause in the common
        provisions.
      </Text>
      {!suppressCashReserve && (
        <SambaAutoLink
          to={urlBuilder.getCashReserveTermsAndConditions()}
          target="_blank"
          onClick={() => trackClick({ name: 'cashReserveTerms', flow: 'UserProfileSetup' })}
          css={{ display: 'inline-block', marginBottom: '2rem' }}
        >
          Cash Reserve terms and conditions
        </SambaAutoLink>
      )}
    </>
  );
};

export default UserAgreementContent;
